import React from 'react';
import cx from 'classnames';
import styles from './SocialIcon.module.css';
import Link from '../Icons/Link';
import Facebook from '../Icons/Facebook';
import Instagram from '../Icons/Instagram';
import Youtube from '../Icons/Youtube';
import Linkedin from '../Icons/Linkedin';
import Twitter from '../Icons/Twitter';

const IconMap = {
  link: Link,
  facebook: Facebook,
  instagram: Instagram,
  youtube: Youtube,
  linkedin: Linkedin,
  twitter: Twitter,
};

export default ({ href, platform, circle }) => {
  const Icon = IconMap[platform] || (() => null);
  return (
    <a
      className={cx(styles.iconLink, circle && styles.circle)}
      href={href}
      target="_blank"
      rel="noopener noreferrer nofollow"
    >
      <Icon color={circle ? '#F0EEEC' : 'black'} />
    </a>
  );
};
